module.exports = __webpack_public_path__ + "static/cely_rose_sombre-7780ba8eef9da400697b5c5a1604471d.jpg";